import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, IDField, GoogleButton } from "@/components/AuthShell";
import { IDButton } from "@/marketing/brand";
import { toast } from "sonner";

export default function Login() {
  const { user, loading, login, devLogin, startEmergentGoogle } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  if (!loading && user) return <Navigate to="/dashboard" replace />;

  const dest = () => "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(f.email.trim(), f.password);
      navigate(dest(u));
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid email or password.");
    } finally { setBusy(false); }
  };

  const handleDev = async () => {
    setBusy(true);
    try { const u = await devLogin(); navigate(dest(u)); }
    catch { toast.error("Could not sign in."); }
    finally { setBusy(false); }
  };

  return (
    <AuthShell title="Welcome back" subtitle="Sign in to continue living each day on purpose."
      footer={<p className="id-sans text-center text-sm text-[var(--id-charcoal)]/60">New to Intrinsic Daily? <Link to="/signup" className="text-[var(--id-walnut)] font-medium id-link-underline">Create an account</Link></p>}>
      <GoogleButton onClick={startEmergentGoogle} />
      <div className="my-6 flex items-center gap-4">
        <div className="h-px flex-1 bg-[var(--id-mist)]" />
        <span className="id-sans text-[11px] uppercase tracking-[0.18em] text-[var(--id-charcoal)]/45">or with email</span>
        <div className="h-px flex-1 bg-[var(--id-mist)]" />
      </div>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <IDField label="Email" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="you@example.com" data-testid="login-email" autoComplete="email" />
        <IDField label="Password" type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="Your password" data-testid="login-password" autoComplete="current-password" />
        <div className="flex justify-end -mt-1">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="id-sans text-[13px] text-[var(--id-walnut)] id-link-underline">Forgot password?</Link>
        </div>
        <IDButton as="button" type="submit" variant="solid" disabled={busy} className="w-full !py-3.5" testid="login-submit">{busy ? "Signing in…" : "Sign in"}</IDButton>
      </form>
      <div className="my-6 flex items-center gap-4">
        <div className="h-px flex-1 bg-[var(--id-mist)]" />
        <span className="id-sans text-[11px] uppercase tracking-[0.18em] text-[var(--id-charcoal)]/45">Owner access</span>
        <div className="h-px flex-1 bg-[var(--id-mist)]" />
      </div>
      <IDButton as="button" onClick={handleDev} variant="ghost" disabled={busy} className="w-full" testid="dev-login-button">Enter as owner</IDButton>
    </AuthShell>
  );
}
